import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import {
    showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs, Btn, H6 } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { getPackage, getPackageRate, getPackageRatesList, getPackagesList, getPackagesListBySearch, getPackagesRateListBySearch } from "../../Services/Packages.service";
import { Plus } from "react-feather";
import PackagesRateTable from "./PackagesRateTable";
import SearchTable from "../Common/Component/SearchTable";
import PackageRateInput from "./PackageRateInput";
import { CalendarViewFunctions } from "./Components/CalendarViewFunctions";
import PackageRateCalendar from "./PackageRateCalendar";
import CustomSelect from "../../CommonElements/CustomSelect";

const calendarViewFunctions = new CalendarViewFunctions()

const PackageRates = () => {
    const { cityData, globalCityField, setShowApiLoader } =
        useContext(SharedDataContext);
    
    const [loader, setLoader] = useState(false);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [searchData, setSearchData] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);
    const [isOpen, setIsOpen] = useState(false)
    const [editId, setEditId] = useState("")
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 30,
    });
    const [tableData, setTableData] = useState([]);
    const [isToggled, setIsToggled] = useState(false)
    const [calendarData, setCalendarData] = useState([])
    const [tableHeaders, setTableHeaders] = useState([])
    const [packagesData, setPackagesData] = useState([])
    const [selectedPackage, setSelectedPackage] = useState({})

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination({
            ...pagination,
            pageIndex: page - 1
        });
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setPagination({
            ...pagination,
            pageSize: currentRowsPerPage
        });
    };

    const onPackageNameClicked = (packageDetails) => {
        setSelectedPackage(packageDetails)
        setIsOpen(true)
    }

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination.pageIndex, pagination.pageSize]);

    const fetchTableData = () => {
        if (!searchData) {
            const serviceCityId = globalCityField.value?.id || '0';
            let obj = {
                serviceCityId: serviceCityId,
                page: pagination.pageIndex,
                size: pagination.pageSize,
            };
            setLoader(true);
            getPackageRatesList(obj)
                .then(async (result) => {
                    console.log("packageRate List from table is ",result.data)
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.searchResponse);
                    setCalendarData(await calendarViewFunctions.getCalendarData(result.data.searchResponse, onEditClick, onPackageNameClicked))
                    setTableHeaders(await calendarViewFunctions.getTableHeaderWithHours())
                    disableLoaders();
                })
                .catch((err) => {
                    console.log("err", err)
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (searchData && filterType == "search") {
            const serviceCityId = globalCityField.value?.id || null;
            let obj = {
                serviceCityId: serviceCityId,
                name: searchData,
                page: pagination.pageIndex,
                size: pagination.pageSize,
            };
            setLoader(true);
            getPackagesRateListBySearch(obj)
                .then(async (result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.searchResponse);
                    setCalendarData(await calendarViewFunctions.getCalendarData(result.data.searchResponse, onEditClick, onPackageNameClicked))
                    setTableHeaders(await calendarViewFunctions.getTableHeaderWithHours())
                    disableLoaders();
                })
                .catch((err) => {
                    console.log("err", err)
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        }
    };

    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };

    const onEditClick = (obj) => {
        setIsOpen(true)
        setEditId(obj.id)
    }

    useEffect(() => {
        if (!searchData && filterType != "search") {
            fetchTableData()
            return;
        }
        setPagination({
            pageIndex: 0,
            pageSize: 30,
        })
        fetchTableData()
    }, [searchData]);

    const toggleModal = () => {
        fetchTableData()
        setEditId("")
        setIsOpen(!isOpen)
    }

    const toggleBar = () => {
        setIsToggled(!isToggled)
        setSearchData("")
        setFilterType("")
        setPagination({
            pageIndex: 0,
            pageSize: 30,
        })
    }

    useEffect(() => {
        const fetchTableData = () => {
            const serviceCityId = null;
            let obj = {
                isPagination: false,
                serviceCityId: serviceCityId,
                page: 0,
                size: 30,
            };
            getPackagesList(obj)
                .then((result) => {
                    let packageOptions = result.data.list.map((d) => {
                        return {
                            label: d.name,
                            value: d
                        }
                    })
                    setPackagesData(packageOptions);
                })
            // .catch((err) => {
            //     showAlert("error", err.response?.data?.message
            //         ? err.response.data.message : "Something went wrong");
            // });
        };
        fetchTableData()
    }, [])

    return (
        <Fragment>
            <Breadcrumbs
                parent="Configuration"
                subParent="Packages"
                mainTitle="Packages"
                span1={
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "end", marginRight: "10px" }}>
                        <i className="fa fa-table" onClick={toggleBar} style={{ fontSize: "28px", marginBottom: "5px", cursor: "pointer" }}></i>
                        <div className="custom-toggle-switch" style={{ margin: "0px 10px" }}>
                            <input
                                type="checkbox"
                                checked={isToggled ? true : false}
                                onChange={toggleBar}
                                id={"switch"}
                            />
                            <label htmlFor="switch"></label>
                        </div>
                        <i className="fa fa-calendar" onClick={toggleBar} style={{ fontSize: "25px", marginBottom: "8px", cursor: "pointer" }}></i>
                    </div>
                }
                span3={
                    isToggled ? <div style={{ width: "250px" }}><CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        // value={packageField?.value?.id ? packagesData.find((element) => {
                        //     return element?.value?.id === packageField?.value?.id;
                        // }) : ""}
                        menuPortalTarget={document.body}
                        onChange={(d) => {
                            if (d.value?.name) {
                                setSearchData(d.value.name)
                                setFilterType("search")
                            }else{
                                setSearchData("")
                                setFilterType("")
                            }
                        }}
                        placeholder="Select Package"
                        options={[
                            { label: "All", value: { name: "" } },
                            ...packagesData
                        ]}
                    /></div> : <SearchTable
                        searchData={searchData}
                        setSearchData={setSearchData}
                        setFilterData={setFilterData}
                        setFilterType={setFilterType}
                        placeholder={"Search Package Name"}
                    />
                }
                span2={
                    <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: (e) => setIsOpen(true) }}>
                        <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
                    </Btn>
                }
            />
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                {isToggled ?
                                    (<PackageRateCalendar
                                        packageRatesData={tableData}
                                        calendarData={calendarData}
                                        setCalendarData={setCalendarData}
                                        tableHeaders={tableHeaders}
                                        setTableHeaders={setTableHeaders}
                                        pagination={pagination}
                                        setPagination={setPagination}
                                        paginationTotalRows={paginationTotalRows}
                                        onEditClick={onEditClick}
                                        loader={loader}
                                    />)
                                    :
                                    (<PackagesRateTable
                                        fetchTableData={fetchTableData}
                                        tableData={tableData}
                                        setShowApiLoader={setLoader}
                                        onChangePage={onChangePage}
                                        paginationPerPage={pagination.pageSize}
                                        paginationTotalRows={paginationTotalRows}
                                        onChangeRowsPerPage={onChangeRowsPerPage}
                                        onEditClick={onEditClick}
                                        loader={loader}
                                    />)}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <PackageRateInput editId={editId} isOpen={isOpen} toggleModal={toggleModal} packagesData={packagesData} selectedPackage={selectedPackage} />
        </Fragment>
    );
};

export default PackageRates;
